<div class="container-xl">
    <h3>Afas koppeling</h3>
    <div class="row mb-4">
        <div class="col-2 text-center align-items-center justify-content-center d-flex pr-0">
            <i class="fa fa-2x" [class.fa-check]="afasUser" [class.fa-crosshairs]="!afasUser"></i>
        </div>
        <div class="col-auto pl-0">
            <b>{{ afasUser ? 'Gekoppeld aan Afas' : 'Niet gekoppeld aan Afas' }}</b>
            <br />
            @if (afasUser) {
                {{ afasUser.userId }} / {{ afasUser?.personId }} / {{ afasUser?.description }}
            }
            Omgeving: {{ environmentTest }}
        </div>
        @if (!otpRequesting && !otpRequested) {
            <div class="col">
                @if (afasUser) {
                    <button (click)="deleteTokens()" mat-raised-button color="warn">Ontkoppelen</button>
                } @else if (environmentCode) {
                    <button (click)="otpRequest = true" mat-raised-button color="primary">Koppelen</button>
                } @else {
                    Environmentcode niet ingesteld
                }
            </div>
        }
    </div>
    <div class="row">
        <div class="col-24">
            @if (otpRequest && environmentCode) {
                <form class="example-form" name="a">
                    <h3>Activatiecode Afas aanvagen</h3>
                    <mat-form-field>
                        <span matPrefix>{{ environmentCode }}.</span>
                        <input
                            #nameInput="ngModel"
                            [(ngModel)]="user"
                            matInput
                            placeholder="Gebruikersnaam AFAS"
                            minlength="2"
                            required
                            maxlength="20"
                            name="name" />
                        @if (nameInput.errors) {
                            <mat-error> Vul je gebruikersnaam in </mat-error>
                        }
                    </mat-form-field>
                    <br />
                    @if (requestOtpError) {
                        <div class="mat-error">Er is iets fout gegaan ({{ requestOtpError }})<br /><br /></div>
                    }
                    <button [disabled]="otpRequesting" (click)="requestOtp()" mat-raised-button color="primary">
                        {{ otpRequesting ? 'Aan het versturen...' : 'Verstuur activatiecode' }}
                    </button>
                </form>
            }
            @if (otpRequested) {
                <form>
                    <h3>Activatiecode Afas invullen</h3>
                    <p>
                        Er is een activatiecode verstuurd naar het e-mailadres gekoppeld aan
                        <b>{{ environmentCode }}.{{ user }}</b
                        >. Vul dit wachtwoord hieronder in.
                        <br />
                        <b>Let op:</b> dit is niet het wachtwoord waarmee je inlogt bij Afas Profit.
                    </p>
                    <mat-form-field class="mb-3">
                        <input
                            id="passwordField"
                            #otpInput="ngModel"
                            [(ngModel)]="otp"
                            matInput
                            placeholder="activatiecode"
                            name="otp"
                            required
                            numeric
                            minlength="6" />
                        @if (otpInput.errors) {
                            <mat-error> Vul de activatiecode in dat je per e-mail ontvangen hebt </mat-error>
                        }
                    </mat-form-field>
                    @if (validateOtpError) {
                        <div class="mat-error">Er is iets fout gegaan ({{ validateOtpError }})<br /><br /></div>
                    }
                    <div class="button-row">
                        <button
                            class="mb-2"
                            [disabled]="otpValidating"
                            (click)="validateOtp()"
                            mat-raised-button
                            color="primary">
                            {{ otpValidating ? 'Activatiecode valideren...' : 'Activatiecode bevestigen' }}
                        </button>
                        <button (click)="reset()" mat-raised-button>Opnieuw proberen</button>
                    </div>
                </form>
            }
        </div>
    </div>
</div>
<div class="col-24">
    @if (relForm) {
        <form [formGroup]="relForm">
            <ng-select [clearable]="true" formControlName="EmId" placeholder="Boeken op">
                @for (mat of materieel; track mat) {
                    <ng-option [value]="mat.employeeId"
                        >{{ mat.firstName }} {{ mat.birthName }} ({{ mat.functionDesc }})</ng-option
                    >
                }
                @for (mat of employees; track mat) {
                    <ng-option [value]="mat.employeeId"
                        >{{ mat.firstName }} {{ mat.birthName }} ({{ mat.functionDesc }})</ng-option
                    >
                }
            </ng-select>
            <ng-select
                [clearable]="true"
                [selectableGroup]="false"
                [items]="projects"
                formControlName="PrId"
                placeholder="Project"
                groupBy="mainProject"
                bindLabel="description"
                bindValue="projectId">
                <ng-template ng-label-tmp let-item="item">
                    <b>{{ item.projectId }}</b> {{ item.description }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index">
                    <b>{{ item.projectId }}</b> {{ item.description }}
                </ng-template>
            </ng-select>
            <ng-select
                [items]="hourtypes"
                formControlName="StId"
                placeholder="Uursoort"
                bindLabel="description"
                bindValue="code">
            </ng-select>
            <mat-form-field class="w-100" id="DaTi">
                <input formControlName="DaTi" matInput name="datum" placeholder="Datum (yyyy-mm-dd)" type="text" />
                <mat-error>Dit veld moet minimaal 3 tekens bevatten</mat-error>
            </mat-form-field>
            <mat-form-field class="w-100" id="Ds">
                <input formControlName="Ds" matInput name="description" placeholder="Omschrijving" type="text" />
                <mat-error>Vul een correct e-mailadres in</mat-error>
            </mat-form-field>
            <mat-form-field class="w-100" id="Qu">
                <input
                    [decimalInput]="4"
                    appDecimalInput
                    formControlName="Qu"
                    matInput
                    name="aantal"
                    placeholder="Aantal"
                    type="text" />
                <mat-error>Vul een correct e-mailadres in</mat-error>
            </mat-form-field>
            <div class="row justify-content-center">
                <div class="col-24">
                    <div class="d-flex">
                        <div class="spacer"></div>
                        <button
                            id="btn-save-rea"
                            [disabled]="relForm.invalid || savingRealization"
                            (click)="saveRealization()"
                            color="primary"
                            mat-raised-button>
                            Opslaan
                            @if (savingRealization) {
                                <i class="fas fa-circle-notch fa-spin"></i>
                            }
                        </button>
                    </div>
                </div>
            </div>
        </form>
    }
</div>
<div class="container-fluid pb-5">
    <h3>Uren</h3>
    <ng-select
        [formControl]="fcEmployee"
        [clearable]="true"
        name="employee-filter"
        placeholder="Kies materieel of medewerker">
        @for (mat of materieel; track mat) {
            <ng-option [value]="mat.employeeId">
                {{ mat.firstName }} {{ mat.birthName }} ({{ mat.functionDesc }})
            </ng-option>
        }
        @for (employee of employees; track employee) {
            <ng-option [value]="employee.employeeId">
                {{ employee.firstName }} {{ employee.birthName }} ({{ employee.functionDesc }})
            </ng-option>
        }
    </ng-select>
    <table class="table table-striped">
        <thead>
            <tr>
                <th>identity</th>
                <th>year</th>
                <th>periodId</th>
                <th>Datum</th>
                <th>employeeId</th>
                <th>projectId</th>
                <th>description</th>
                <th>itemType</th>
                <th>itemCodeId</th>
                <th>Aantal</th>
                <th>chargeable</th>
                <th>approved</th>
                <th>prepared</th>
                @if (false) {
                    <th>dateModified</th>
                }
                @if (false) {
                    <th>systemDate</th>
                }
            </tr>
        </thead>
        <tbody>
            @for (rea of realization; track rea) {
                <tr>
                    <td>{{ rea.identity }}</td>
                    <td>{{ rea.year }}</td>
                    <td>{{ rea.periodId }}</td>
                    <td class="text-nowrap">{{ rea.dateTime | date: 'EEE dd MMM y HH:mm' }}</td>
                    <td>{{ rea.employeeId }}</td>
                    <td>{{ rea.projectId }}</td>
                    <td>{{ rea.description }}</td>
                    <td>{{ rea.itemType }}</td>
                    <td>{{ rea.itemCodeId }}</td>
                    <td>{{ rea.quantityUnit }} {{ rea.initId }}</td>
                    <td>{{ rea.chargeable }}</td>
                    <td>{{ rea.approved }}</td>
                    <td>{{ rea.prepared }}</td>
                    @if (false) {
                        <td class="text-nowrap">{{ rea.dateModified | date: 'EEE dd MMM y HH:mm' }}</td>
                    }
                    @if (false) {
                        <td class="text-nowrap">{{ rea.systemDate | date: 'EEE dd MMM y HH:mm' }}</td>
                    }
                </tr>
            }
        </tbody>
    </table>
    @if (loadingRealization) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
</div>
